import store from "../store";

export default async function is_test_retoucher({ next, router }) {
    await store.dispatch('profile/role');
    let role = await store.getters['profile/role'];
    if (role !== 'test-retoucher') {
        return router.push({ name: "User Profile" });
    }

    return next();
}
